import axios from "axios";
import { createApiFactory } from "./apiFactory";
import { REACT_APP_BACKEND_URL, REACT_APP_BACKEND_URL_LOGIN } from "../config";


const api = axios.create({
	baseURL: `${REACT_APP_BACKEND_URL}/api/v1` ,
	withCredentials: true,
});
export const apione = axios.create({
	baseURL: `${REACT_APP_BACKEND_URL_LOGIN}/api/v1` ,
	withCredentials: true,
});

export const openApi = axios.create({
	baseURL: `${REACT_APP_BACKEND_URL_LOGIN}/api/v1`,
	withCredentials: true
});

export const coreApi = createApiFactory(api);
export const authApi = createApiFactory(apione);
export const publicApi = createApiFactory(openApi);

export default api;
